export type DeepPartial<T> = T extends object
  ? { [P in keyof T]?: DeepPartial<T[P]> }
  : T;

export function numberToColumn(num: number): string {
  let column = '';
  while (num > 0) {
    const remainder = (num - 1) % 26;
    column = String.fromCharCode(65 + remainder) + column;
    num = Math.floor((num - 1) / 26);
  }
  return column;
}

export function columnToNumber(column: string): number {
  let num = 0;
  for (let i = 0; i < column.length; i++) {
    num = num * 26 + column.charCodeAt(i) - 64;
  }
  return num;
}

export function toCamelCase(str: string): string {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
      index === 0 ? word.toLowerCase() : word.toUpperCase(),
    )
    .replace(/\s+/g, '');
}

export function deepMerge<T>(
  base: T,
  ...partials: (DeepPartial<T> | null | undefined)[]
): T {
  const result = { ...base };
  for (const partial of partials) {
    for (const key in partial) {
      if (typeof partial[key] === 'object' && partial[key] !== null) {
        // @ts-expect-error
        if (typeof result[key] !== 'object' || result[key] === null) {
          // @ts-expect-error
          result[key] = {};
        }
        // @ts-expect-error
        result[key] = deepMerge(result[key], partial[key]);
      } else {
        // @ts-expect-error
        result[key] = partial[key];
      }
    }
  }
  return result as T;
}
